import { useRef, useEffect } from "react";
import "./Recommendation.scss";
import likeIcon from "../../assets/icons/likes.svg";
import filledLike from "../../assets/icons/filled-likes.svg";

// A recommendation card: track/artist, a Spotify player (which already shows
// the album art), an always-visible AI "why you'll like this" note, and a
// heart that toggles save/unsave.
export default function Recommendation({
  recommendation,
  onToggleSave,
  saved = false,
  saving = false,
  iframeApi,
  index,
}) {
  const embedRef = useRef();
  const explanation = recommendation.chatGPT;

  useEffect(() => {
    if (iframeApi && recommendation && embedRef.current) {
      iframeApi.createController(
        embedRef.current,
        { width: "100%", height: "152", uri: recommendation.artist_uri },
        () => {}
      );
    }
  }, [iframeApi, recommendation]);

  return (
    <article className="rec">
      <div className="rec__head">
        <div className="rec__titles">
          {index != null && (
            <span className="rec__index">{String(index + 1).padStart(2, "0")}</span>
          )}
          <h3 className="rec__track">{recommendation.track_title}</h3>
          <p className="rec__artist">{recommendation.artist_name}</p>
        </div>

        {onToggleSave && (
          <button
            type="button"
            className={`rec__heart${saved ? " rec__heart--on" : ""}`}
            onClick={() => onToggleSave(recommendation)}
            disabled={saving}
            aria-pressed={saved}
            aria-label={saved ? "Remove from your finds" : "Save to your finds"}
          >
            <img src={saved ? filledLike : likeIcon} alt="" />
          </button>
        )}
      </div>

      <div className="rec__embed" ref={embedRef} />

      {explanation && (
        <div className="rec__why">
          <span className="rec__why-label">Why you might like this</span>
          <p className="rec__why-text">{explanation}</p>
        </div>
      )}
    </article>
  );
}
